module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sferumGroup"
  }, [_c('div', {
    staticClass: "sferumGroupHeader"
  }, [_c('p', {
    staticClass: "sferumGroupHeaderName"
  }, [_vm._v("Группа: " + _vm._s(_vm.group.group_name))]), _c('AppButtonNew', {
    attrs: {
      "target": "blank",
      "type": _vm.getButtonType.medium_button_fill,
      "to": _vm.group.chat_link
    }
  }, [_vm._v("Перейти в чат группы")])], 1), _c('div', {
    staticClass: "sferumGroupWebinars"
  }, _vm._l((_vm.getChildren), function(webinar) {
    return _c('InfoSferumWebinar', {
      key: webinar.id,
      attrs: {
        "item": webinar
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44bc7016","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/infoSferum/SferumWebinarGroup.vue
// module id = 0cba1388d075c0ffdacb
// module chunks = 14